import { Collapse, CollapseItem, Button, Popover, Select, Option, } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
const svc = new ResourceSvc();
import RaceResult from '@/components/shared/race-result/race-result.vue'
import RacesView from '@/components/user/ranking/races-view/races-view.vue'
import FilterBar from '@/components/admin/ranking/filter-bar/filter-bar.vue';

export default {
    name: 'RacesList',
    props: ['selectedSerieIndex', 'selectedYearIndex'],
    components: {
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Button.name]: Button,
        [Popover.name]: Popover,
        [Select.name]: Select,
        [Option.name]: Option,
        'race-result': RaceResult,
        'races-view': RacesView,
        'filter-bar': FilterBar
    },
    data() {
        return {
            perPage: 10,
            organizations: [],
            distances: [],

            isPreviewRaceResultsMode: false,
            isProcessing: false,
            errorMessage: null,
            data: [],
            years: ["Initialization"],
            series: ["Initialization"],
            selectedYear: null,
            selectedYearLabel: null,
            selectedSerie: null,
            selectedSerieLabel: null,
            noRacesEntry: { name: "No races found", id: null, enumValue: 0 },
            races: [],
            racesInput: [],
            racesFiltered: [],
            activeRaceId: null,
            loadedResults: null
        };
    },
    computed: {
        currentRaceName() {
            var race = this.races.filter(x => x.id == this.activeRaceId);
            return race && race.length ? race[0].name : null;
        },
        isAnyRacesLoaded() {
            return !this.racesInput || !this.racesInput.length || this.racesInput[0].id;
        },
        isVisibleWorkflow() {
            return this.years && this.years.length && this.series && this.series.length;
        },
        isNotVisibleWorkflow() {
            return !this.isVisibleWorkflow && !this.isProcessing;
        },
    },
    methods: {
        serialize(obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        },
        showError(message) {
            if (!message) message = 'Something went wrong. Incorrect request!';
            this.$notify({ message: message, type: 'danger', timeout: 3000 });
        },
        showSuccess(message) {
            if (!message) message = 'Operation success!';
            this.$notify({ message: message, type: 'success', timeout: 3000 });
        },
        console(message) {
            if (console && console.log) {
                if (message) console.log(message);
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        setTabsInit() {
            var self = this;
            if (self.series && self.series.length) {
                self.selectedSerieLabel = self.series[self.selectedSerieIndex > -1 ? self.selectedSerieIndex : 0].label;
                self.selectedSerie = self.series[self.selectedSerieIndex > -1 ? self.selectedSerieIndex : 0].enumValue;
            }
            if (self.years && self.years.length) {
                self.selectedYear = self.years[self.selectedYearIndex > -1 ? self.selectedYearIndex : 0];
                self.selectedYearLabel = self.years[self.selectedYearIndex > -1 ? self.selectedYearIndex : 0] + '';
            }
            self.updateRaces();
        },
        init() {
            var self = this;
            self.isProcessing = true;
            self.races = [self.noRacesEntry];
            self.years = [];
            self.series = [];
            svc.rankingInitSeriesSettings()
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body) {
                        self.series = response.body.series;
                        self.years = response.body.years
                        self.setTabsInit();
                    }
                    else {
                        self.errorMessage = "Something went wrong, please contact with dev team!";
                    }
                }, () => {
                    self.isProcessing = false;
                    self.errorMessage = "Something went wrong, please contact with dev team!";
                });

            EventBus.$off('view-race-results');
            EventBus.$on('view-race-results', id => self.loadRaceResult(id));

            EventBus.$off('user-ranking-filter-updated');
            EventBus.$on('user-ranking-filter-updated', updateModel => self.searchForRaces(true, updateModel));

            EventBus.$off('user-ranking-change-page');
            EventBus.$on('user-ranking-change-page', (newPage, perPage) => { self.perPage = perPage; self.changePage(newPage, perPage); });
        },
        handleTabChangeSerie(tabIndex) {
            var self = this;
            if (self.isProcessing) {
                return;
            }
            
            self.selectedSerie = self.series[tabIndex].enumValue;
            self.updateRaces();

            if (self.selectedSerieIndex != tabIndex) {
                EventBus.$emit('ranking-layout-set-init-serie-index', tabIndex);
            }
        },
        handleTabChangeYear(tabIndex) {
            var self = this;
            if (self.isProcessing) {
                return;
            }
            
            self.selectedYear = self.years[tabIndex];
            self.updateRaces();

            if (self.selectedYearIndex != tabIndex) {
                EventBus.$emit('ranking-layout-set-init-year-index', tabIndex);
            }
        },
        clearRaces() {
            var self = this;
            self.racesAll = [];
            self.racesFiltered = [];
            self.races = [];
            self.organizations = [];
            self.distances = [];
        },
        changePage(newPage, perPage) {
            var from = newPage ? (newPage - 1) * perPage : (this.page - 1) * perPage;
            if (from >= this.racesFiltered.length) {
                if (this.racesFiltered.length - perPage > 0) {
                    from = this.racesFiltered.length - perPage;
                }
                else {
                    from = 0;
                    this.page = 1;
                }
            }

            if (newPage) {
                this.races = [...this.racesFiltered].splice(from, perPage);
            }
            else {
                this.page = 1;
                this.races = [...this.racesFiltered].splice(from, perPage);
            }
        },
        searchForRaces(savePage, updateModel) {
            if (!savePage) {
                this.page = 1;
            }
            if (!updateModel) {
                this.racesFiltered = [...this.racesInput];
                this.races = [...this.racesFiltered].splice(0, this.perPage);
                return;
            }

            if (updateModel.startDateRange && updateModel.startDateRange.length > 1) {
                updateModel.startDateRange[0].setHours(1, 1, 1);
                updateModel.startDateRange[1].setHours(23, 59, 59);
            }

            var lowerfilterInput = updateModel.filterInput && updateModel.filterInput.length ? updateModel.filterInput.toLocaleLowerCase() : null;
            this.racesFiltered = [...this.racesInput
                .filter(race => {
                    return (!lowerfilterInput || race.raceName.toLocaleLowerCase().indexOf(lowerfilterInput) > -1 || race.id == lowerfilterInput) &&
                        (updateModel.selectedDistance == "All" || updateModel.selectedDistance == race.distance) &&
                        (updateModel.selectedTypeByEvent == "All" || updateModel.selectedTypeByEvent == race.typeByEvent) &&
                        (updateModel.selectedOrganizationName == "All" || updateModel.selectedOrganizationName == race.organizationName || updateModel.selectedOrganizationName == race.clubName) &&
                        (!updateModel.startDateRange || updateModel.startDateRange.length != 2 || (updateModel.startDateRange[0] <= race.startTime && updateModel.startDateRange[1] >= race.startTime));
                })];
            this.races = [...this.racesFiltered].splice(0, updateModel.perPage);
        },
        prepareRacesFromResponse(response) {
            var self = this;
            if (response && response.body && response.body.isSuccess) {
                self.racesInput = response.body.outputData && response.body.outputData.length ? response.body.outputData : [self.noRacesEntry];
                self.organizations = [...new Set(self.racesInput.map(x => {
                    x.startTime = new Date(x.startTime);
                    return x.organizationName ? x.organizationName : x.clubName;
                }).filter(x => x))];

                self.organizations.unshift("All");
                self.distances = [...new Set(self.racesInput.map(x => { return x.distance }))];
                self.distances.unshift("All");
                EventBus.$emit('filter-bar-update');
            }
            else {
                self.errorMessage = response && response.body && response.body.message ? response.body.message : "Error while retrieving data.";
            }
        },
        updateRaces() {
            var self = this;
            self.clearRaces()

            if (self.selectedYear && self.selectedSerie) {
                self.isProcessing = true;
                const filterQuery = self.serialize({ serieType: self.selectedSerie, year: self.selectedYear });
                svc.rankingGetRaces(filterQuery)
                    .then(response => {
                        self.prepareRacesFromResponse(response);
                        self.isProcessing = false;
                    }, () => {
                        self.errorMessage = "Error while retrieving data."
                        self.isProcessing = false;
                    });
            }
        },
        loadRaceResult(activeRaceId) {
            this.activeRaceId = activeRaceId;
            this.isPreviewRaceResultsMode = this.activeRaceId > 0;
            EventBus.$emit('race-result-reload');
        },
        download() {
            EventBus.$emit('race-result-download');
        },
        switchPreview() {
            var self = this;
            self.isPreviewRaceResultsMode = !self.isPreviewRaceResultsMode;
            setTimeout(() => {
                var item = document.getElementById('head-' + self.activeRaceId);
                if (item && item.getBoundingClientRect && item.getBoundingClientRect()) {
                    window.scrollTo({ top: item.getBoundingClientRect().y - 100, behavior: 'smooth' });
                }
            }, 10)
        }
    },
    mounted() {
        this.init();
    }
};



// WEBPACK FOOTER //
// ./src/components/user/ranking/races-list/races-list.js